import { ErrorHandler, Injectable, inject } from '@angular/core';
import {
  ApplicationInsightsService,
  SeverityLevel,
} from './application-insights.service';

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
  private readonly appInsights = inject(ApplicationInsightsService);

  handleError(error: unknown): void {
    const errorObj = error instanceof Error ? error : new Error(String(error));

    this.appInsights.trackException(
      errorObj,
      {
        source: 'GlobalErrorHandler',
        originalError: String(error),
      },
      SeverityLevel.Critical
    );

    console.error('Unhandled error:', error);
  }
}
